var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJuara1New(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1889_14862",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.0007,
    r: 12,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1889_14862)"
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.0007,
    r: 12,
    fill: "#F0F2F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.21598 18.1539L8.19848 18.1764C8.09686 18.2933 7.97272 18.3885 7.83348 18.4564C7.71508 18.5108 7.58629 18.5389 7.45598 18.5389C7.39131 18.5384 7.32685 18.5317 7.26348 18.5189L7.70598 17.7514C7.85304 17.546 7.9519 17.31 7.99518 17.0612C8.03846 16.8123 8.02506 16.5568 7.95598 16.3139C7.84598 15.9989 7.64848 15.9614 7.58348 15.9489H7.55598C6.33208 15.6133 5.20368 14.996 4.26098 14.1464C4.11348 14.0139 3.97098 13.8789 3.83348 13.7364C3.69598 13.5939 3.54098 13.4039 3.40098 13.2364C3.08403 12.8563 2.7989 12.4507 2.54848 12.0239C1.82544 10.7906 1.39203 9.40914 1.28098 7.98386L1.25098 7.62886L1.42598 7.51636L5.12598 7.62886L5.11098 7.97136C5.11098 7.97136 5.08098 8.90636 5.61098 9.47136C5.73329 9.60331 5.88133 9.70881 6.04598 9.78136C6.27412 9.88023 6.51984 9.93209 6.76848 9.93386L6.94348 10.6489C6.64335 10.6304 6.34594 10.581 6.05598 10.5014C5.70528 10.3981 5.38854 10.203 5.13848 9.93636C4.74384 9.47642 4.50878 8.90105 4.46848 8.29636H1.96848C2.06234 9.06854 2.25735 9.82503 2.54848 10.5464C2.77515 11.1084 3.06093 11.6447 3.40098 12.1464C3.53848 12.3514 3.68598 12.5464 3.83848 12.7339C3.99098 12.9214 4.11598 13.0639 4.26598 13.2189C5.20733 14.2126 6.40184 14.9309 7.72098 15.2964C7.77531 15.3075 7.82878 15.3226 7.88098 15.3414C8.04775 15.4037 8.19777 15.5038 8.31925 15.634C8.44072 15.7641 8.53031 15.9207 8.58098 16.0914C8.68554 16.4398 8.70698 16.8078 8.64359 17.166C8.58021 17.5242 8.43375 17.8625 8.21598 18.1539Z",
    fill: "url(#paint0_linear_1889_14862)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.74992 8.07167L4.46742 8.28667H2.02742L1.91992 7.89917L4.74992 8.07167Z",
    fill: "#808080"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.21715 18.1531L8.19965 18.1756C8.09804 18.2925 7.9739 18.3877 7.83465 18.4556C7.71625 18.51 7.58746 18.5382 7.45715 18.5381C7.39249 18.5376 7.32802 18.531 7.26465 18.5181L7.43965 18.4056L8.21715 18.1531Z",
    fill: "#808080"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37133 18.0639C8.26696 18.1803 8.14029 18.2747 7.99883 18.3414C7.8806 18.3966 7.75182 18.4256 7.62133 18.4264C7.55667 18.4259 7.4922 18.4192 7.42883 18.4064L7.87133 17.6289C8.01774 17.4231 8.11619 17.1872 8.15945 16.9385C8.20272 16.6897 8.18969 16.4344 8.12133 16.1914C8.01133 15.8764 7.81383 15.8389 7.74633 15.8264H7.72133C6.49743 15.4908 5.36903 14.8735 4.42633 14.0239C4.27883 13.8914 4.13633 13.7539 3.99883 13.6139C3.86133 13.4739 3.71383 13.2914 3.57383 13.1239C3.25688 12.7438 2.97175 12.3382 2.72133 11.9114C1.99861 10.6778 1.56443 9.29659 1.45133 7.87136L1.42383 7.51636H5.29883L5.28383 7.85886C5.28383 7.85886 5.25383 8.79386 5.78383 9.35886C5.90522 9.49074 6.05244 9.59626 6.21633 9.66886C6.44534 9.76773 6.69189 9.81959 6.94133 9.82136L6.92633 10.4764C6.68609 10.4725 6.44739 10.4372 6.21633 10.3714C5.86606 10.2674 5.55008 10.0715 5.30133 9.80386C4.90623 9.34421 4.6711 8.76867 4.63133 8.16386H2.13133C2.22508 8.93606 2.42009 9.69256 2.71133 10.4139C2.94043 10.983 3.22956 11.526 3.57383 12.0339C3.71133 12.2364 3.85883 12.4339 4.01133 12.6214C4.16383 12.8089 4.28883 12.9514 4.43883 13.1039C5.37951 14.0977 6.57302 14.8168 7.89133 15.1839C7.94602 15.1935 7.99961 15.2086 8.05133 15.2289C8.21886 15.2903 8.36967 15.3902 8.49166 15.5204C8.61365 15.6507 8.70344 15.8077 8.75383 15.9789C8.85949 16.3319 8.87991 16.7049 8.81342 17.0674C8.74693 17.4298 8.59542 17.7713 8.37133 18.0639Z",
    fill: "url(#paint1_linear_1889_14862)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37348 18.0623C8.2691 18.1788 8.14244 18.2731 8.00098 18.3398C8.67598 17.1298 8.30848 15.8398 8.04598 15.2273C8.21351 15.2888 8.36432 15.3886 8.48631 15.5189C8.6083 15.6491 8.69809 15.8061 8.74848 15.9773C8.85518 16.3297 8.87682 16.7025 8.81164 17.0649C8.74645 17.4273 8.5963 17.7691 8.37348 18.0623Z",
    fill: "#808080"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23047 9.67651C6.45948 9.77538 6.70603 9.82724 6.95547 9.82901L6.94047 10.484C6.70023 10.4802 6.46153 10.4449 6.23047 10.379V9.67651Z",
    fill: "#808080"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6737 7.62808L22.6462 7.98308C22.5444 9.26197 22.1847 10.507 21.5887 11.6431C21.4712 11.8656 21.3387 12.0781 21.2162 12.2881C21.0937 12.4981 20.9462 12.6931 20.8012 12.8881C20.5651 13.1989 20.3096 13.4945 20.0362 13.7731C19.0248 14.8054 17.7574 15.5508 16.3637 15.9331H16.3387C16.2476 15.9506 16.1638 15.9946 16.0975 16.0595C16.0313 16.1244 15.9856 16.2074 15.9662 16.2981C15.8502 16.7152 15.8929 17.1606 16.0862 17.5481C16.1236 17.6174 16.168 17.6828 16.2187 17.7431L16.9212 18.4081L16.6712 18.5206C16.6078 18.5335 16.5433 18.5401 16.4787 18.5406C16.3788 18.5446 16.2789 18.5311 16.1837 18.5006C16.089 18.467 15.9998 18.4198 15.9187 18.3606C15.8492 18.3084 15.7847 18.2498 15.7262 18.1856C15.5022 17.8925 15.3509 17.5506 15.2844 17.1877C15.2179 16.8249 15.2382 16.4515 15.3437 16.0981C15.3965 15.9186 15.4925 15.7548 15.6232 15.621C15.754 15.4872 15.9155 15.3875 16.0937 15.3306L16.1962 15.3056C17.6995 14.8857 19.0368 14.0128 20.0262 12.8056C20.3087 12.4632 20.5645 12.0997 20.7912 11.7181C20.9428 11.462 21.0813 11.1983 21.2062 10.9281C21.3473 10.6158 21.4717 10.2962 21.5787 9.97058C21.754 9.4243 21.877 8.86261 21.9462 8.29308H19.4462C19.4059 8.89777 19.1708 9.47314 18.7762 9.93308C18.5255 10.202 18.2068 10.3981 17.8537 10.5006C17.6285 10.5655 17.3956 10.6 17.1612 10.6031L17.1462 9.94808C17.3892 9.94605 17.6295 9.8968 17.8537 9.80308C18.0259 9.72902 18.1808 9.62006 18.3087 9.48308C18.8387 8.91558 18.8087 7.98308 18.8087 7.98308L18.7937 7.64058L19.0437 7.52808L22.6737 7.62808Z",
    fill: "url(#paint2_linear_1889_14862)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2627 8.13448L21.9552 8.28448H19.4727V7.96948L22.2627 8.13448Z",
    fill: "#808080"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9342 7.51636L22.9042 7.87136C22.8033 9.1504 22.4435 10.3956 21.8467 11.5314C21.7292 11.7539 21.5967 11.9664 21.4742 12.1764C21.3517 12.3864 21.2042 12.5814 21.0592 12.7764C20.8239 13.0878 20.5683 13.3834 20.2942 13.6614C19.2837 14.6936 18.0172 15.439 16.6242 15.8214H16.5967C16.5317 15.8339 16.3342 15.8714 16.2242 16.1864C16.109 16.6038 16.1526 17.0492 16.3467 17.4364C16.3827 17.5074 16.4272 17.5737 16.4792 17.6339L16.9217 18.4114C16.8583 18.4241 16.7939 18.4308 16.7292 18.4314C16.6314 18.4317 16.5342 18.4156 16.4417 18.3839C16.3467 18.35 16.2574 18.302 16.1767 18.2414C16.1069 18.1914 16.0432 18.1335 15.9867 18.0689C15.7623 17.776 15.6105 17.4341 15.544 17.0712C15.4775 16.7083 15.4982 16.3347 15.6042 15.9814C15.6562 15.8015 15.7519 15.6373 15.8828 15.5034C16.0137 15.3695 16.1756 15.27 16.3542 15.2139C16.3869 15.2029 16.4203 15.1945 16.4542 15.1889C17.9577 14.7693 19.2951 13.8963 20.2842 12.6889C20.5675 12.348 20.8234 11.9852 21.0492 11.6039C21.2024 11.3477 21.3409 11.0831 21.4642 10.8114C21.6079 10.501 21.7323 10.1821 21.8367 9.85636C22.0147 9.30994 22.1378 8.74716 22.2042 8.17636H19.7042C19.6632 8.78088 19.4282 9.35605 19.0342 9.81636C18.7803 10.0879 18.457 10.285 18.0992 10.3864C17.8748 10.4511 17.6428 10.4855 17.4092 10.4889L17.3942 9.83386C17.6364 9.83157 17.8758 9.78233 18.0992 9.68886C18.2718 9.61545 18.4268 9.5064 18.5542 9.36886C19.0867 8.80136 19.0542 7.86886 19.0542 7.86886L19.0392 7.52636L22.9342 7.51636Z",
    fill: "url(#paint3_linear_1889_14862)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1767 18.2353C16.1069 18.1853 16.0432 18.1274 15.9867 18.0628C15.7623 17.7699 15.6105 17.428 15.544 17.0651C15.4775 16.7022 15.4982 16.3286 15.6042 15.9753C15.6562 15.7954 15.7519 15.6312 15.8828 15.4973C16.0137 15.3634 16.1756 15.2639 16.3542 15.2078C16.0767 15.7503 15.5967 16.9803 16.1767 18.2353Z",
    fill: "#808080"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1093 9.68433V10.3818C17.8849 10.4465 17.6528 10.481 17.4193 10.4843L17.4043 9.82933C17.6465 9.82704 17.8859 9.77779 18.1093 9.68433Z",
    fill: "#808080"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7223 7.07886C17.7223 7.35886 17.7223 7.65136 17.7023 7.95636C17.7023 8.08386 17.7023 8.20636 17.6823 8.34886C17.5691 10.4403 17.1859 12.5082 16.5423 14.5014C15.6623 17.0539 14.2523 19.0939 12.1423 19.0939C8.36727 19.0939 6.81227 12.5514 6.58977 8.15386C6.58977 8.08886 6.58977 8.02136 6.58977 7.95636C6.58977 7.65136 6.57227 7.35886 6.57227 7.07886H17.7223Z",
    fill: "url(#paint4_linear_1889_14862)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4411 14.4082V13.8707H11.6911V10.5932H11.3936V10.0007H12.9386V13.8707H13.1886V14.4082H11.4411Z",
    fill: "#FF9D09"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9405 13.8707V10.0007H11.3955V10.2057H12.753V14.0782H13.003V14.4082H13.183V13.8707H12.9405Z",
    fill: "#767676"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7588 10.2153L12.9388 10.0203V13.8528L12.7588 14.0753V10.2153Z",
    fill: "#767676"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1888 13.8718V14.4093H13.0088V14.1018L13.1888 13.8718Z",
    fill: "#767676"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5415 14.5014C15.9065 16.3414 15.0015 17.9189 13.7515 18.6539C13.2687 18.9425 12.7165 19.0946 12.154 19.0939C8.37898 19.0939 6.82398 12.5514 6.60148 8.15386C6.60148 8.08886 6.60148 8.02136 6.60148 7.95636C6.60148 7.65136 6.58398 7.35886 6.58398 7.07886H10.089L9.92148 7.71386C9.92148 7.71386 10.4415 20.1864 16.5415 14.5014Z",
    fill: "#808080"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8564 18.5814C9.47137 16.9714 7.94387 10.0289 7.50137 7.07886H6.90137C6.90137 7.35886 6.90137 7.65136 6.91887 7.95636C6.91887 8.02136 6.91887 8.08886 6.91887 8.15636C7.13887 12.4864 8.65137 18.9064 12.3064 19.0889L13.8564 18.5814Z",
    fill: "#808080"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7205 7.07886C17.7205 7.35886 17.7205 7.65136 17.7005 7.95636C17.7005 8.08386 17.7005 8.20636 17.6805 8.34886C15.2132 8.07846 12.7326 7.94742 10.2505 7.95636C7.93055 7.95636 6.96305 8.05386 6.57805 8.15386C6.57805 8.08886 6.57805 8.02136 6.57805 7.95636C6.57805 7.65136 6.56055 7.35886 6.56055 7.07886H17.7205Z",
    fill: "#808080"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4169 6.75073L18.3244 7.06073L18.1569 7.62573H6.12187L5.85938 6.75073H18.4169Z",
    fill: "url(#paint5_linear_1889_14862)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0191 19.4739L13.9166 19.5614C13.7737 19.6858 13.6408 19.8212 13.5191 19.9664C13.4289 20.0616 13.3697 20.1818 13.3491 20.3114C13.3513 20.6714 13.3025 21.03 13.2041 21.3764C13.1708 21.495 13.129 21.6112 13.0791 21.7239L13.0591 21.7739C13.0366 21.8164 13.0166 21.8614 12.9941 21.9014C12.7766 22.3089 12.4741 22.5614 12.1416 22.5614C11.9554 22.5545 11.7779 22.4809 11.6416 22.3539C11.4638 22.1926 11.3231 21.9947 11.2291 21.7739C11.0296 21.3125 10.9307 20.8139 10.9391 20.3114C10.9391 20.0139 10.2666 19.4739 10.2666 19.4739V19.4589L10.5166 18.6414H13.7516L13.8816 19.0564L13.9766 19.3564L14.0091 19.4589L14.0191 19.4739Z",
    fill: "#FFBD26"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0141 19.4589H10.2666L10.5241 18.6414H13.7566L13.8866 19.0564L13.9816 19.3564L14.0141 19.4589Z",
    fill: "url(#paint6_linear_1889_14862)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6367 22.3539C11.2217 21.9989 10.9342 21.2189 10.9342 20.3114C10.9342 20.0139 10.2617 19.4739 10.2617 19.4739L10.5242 18.6414H13.7517C13.7517 18.6414 10.4742 18.7889 11.2142 19.5664C11.2642 19.6989 11.7892 19.7314 11.7892 19.7314C11.7892 19.7314 11.2892 21.6314 11.9517 21.7739C12.2717 21.8389 12.0017 22.1014 11.6367 22.3539Z",
    fill: "#808080"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2775 22.5617H11L11.2225 21.7742H13.0575L13.1125 21.9767L13.25 22.4567L13.2775 22.5617Z",
    fill: "url(#paint7_linear_1889_14862)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8031 28.1593H10.4756L11.0006 22.5593H13.2781L13.2881 22.6668L13.8031 28.1593Z",
    fill: "#FFBD26"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0205 19.4729L13.918 19.5604C13.2255 19.5604 12.2555 19.5179 11.918 19.5129C12.108 19.5055 12.2975 19.4871 12.4855 19.4579C12.9662 19.3716 13.437 19.2368 13.8905 19.0554L13.9855 19.3554L14.018 19.4579L14.0205 19.4729Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2885 22.6703L11.751 22.5628L13.251 22.4578L13.286 22.5628L13.2885 22.6703Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4194 6.75073L18.3269 7.06073L9.04688 6.75073H18.4194Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M11.955 21.7742L11.7625 22.5617H11L11.2225 21.7742H11.955Z",
    fill: "#808080"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7631 22.5593L11.4856 28.1593H11.4281H10.4756L11.0006 22.5593H11.7631Z",
    fill: "#808080"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3175 7.62573H6.125L5.875 6.75073H8.105C7.8525 6.91073 7.155 7.54823 11.3175 7.62573Z",
    fill: "#808080"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87437 7.62573H6.12187L5.85938 6.75073H6.48937L6.87437 7.62573Z",
    fill: "#808080"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8,
    d: "M10.3694 13.8195C10.3694 13.8195 9.18941 11.097 9.41941 8.46948H8.33691C8.33691 8.46948 8.61191 12.0495 10.3694 13.8195Z",
    fill: "url(#paint8_linear_1889_14862)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8,
    d: "M14.1328 15.1645C14.1362 15.1371 14.1362 15.1094 14.1328 15.082C14.1803 14.3095 14.1328 8.46948 14.1328 8.46948H17.2278C17.2278 8.46948 17.2828 14.672 14.1328 15.1645Z",
    fill: "url(#paint9_linear_1889_14862)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0215 15.2631C14.069 14.4931 14.0215 8.65308 14.0215 8.65308H15.249C15.249 10.0131 15.1215 13.6406 14.0215 15.2631Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4741 6.75073H12.1416V7.62573H14.4741V6.75073Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6535 6.75073H15.041V7.62573H15.6535V6.75073Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0599 7.51636H20.2949V8.17386H21.0599V7.51636Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0599 11.5984V12.7759C20.8246 13.0873 20.569 13.383 20.2949 13.6609V12.6834C20.5782 12.3425 20.834 11.9797 21.0599 11.5984Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8461 7.51636H21.4736V8.17386H21.8461V7.51636Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8461 9.85229V11.5323C21.7286 11.7548 21.5961 11.9673 21.4736 12.1773V10.8073C21.6173 10.4969 21.7417 10.178 21.8461 9.85229Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57613 7.51636H2.72363V8.17386H3.57613V7.51636Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57613 12.0315V13.1215C3.25918 12.7414 2.97406 12.3359 2.72363 11.909V10.4265C2.95052 10.99 3.23627 11.528 3.57613 12.0315Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44215 7.51636H4.01465V8.17386H4.44215V7.51636Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44215 13.1043V14.0193C4.29465 13.8868 4.15215 13.7493 4.01465 13.6093V12.6218C4.14965 12.7893 4.29215 12.9518 4.44215 13.1043Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9207 18.4054C16.8573 18.4181 16.7929 18.4248 16.7282 18.4254C16.6304 18.4257 16.5332 18.4097 16.4407 18.3779C16.3799 18.0657 16.3481 17.7485 16.3457 17.4304C16.3816 17.5014 16.4261 17.5678 16.4782 17.6279L16.9207 18.4054Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5162 28.1595H12.5137L12.7562 23.782L13.5162 28.1595Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2331 28.1595H12.0781V23.782L12.2331 28.1595Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3105 20.1406C12.6205 20.3006 13.258 20.9956 12.6355 21.7056C12.5289 21.7356 12.4203 21.7582 12.3105 21.7731C12.547 21.7663 12.7821 21.8098 13.0005 21.9006C13.0437 21.9202 13.084 21.9454 13.1205 21.9756L13.0655 21.7731L13.0855 21.7231C13.0855 21.7006 13.1055 21.6756 13.113 21.6531C13.1262 21.6254 13.1379 21.597 13.148 21.5681C13.1705 21.5081 13.1905 21.4431 13.2105 21.3756C13.309 21.0292 13.3578 20.6706 13.3555 20.3106C13.3761 20.1811 13.4354 20.0608 13.5255 19.9656C13.1317 20.0848 12.7221 20.1438 12.3105 20.1406Z",
    fill: "#808080"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1889_14862",
    x1: 8.08098,
    y1: 12.6314,
    x2: -1.93152,
    y2: 13.7289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E07022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1889_14862",
    x1: 6.47883,
    y1: 13.3264,
    x2: 0.273828,
    y2: 4.10386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFA11F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1889_14862",
    x1: 15.2437,
    y1: 13.0281,
    x2: 22.6737,
    y2: 13.0281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E07022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1889_14862",
    x1: 15.5042,
    y1: 12.9714,
    x2: 22.9342,
    y2: 12.9714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFA11F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1889_14862",
    x1: 6.56227,
    y1: 13.0864,
    x2: 17.7223,
    y2: 13.0864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFBD26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1889_14862",
    x1: 5.85938,
    y1: 7.18823,
    x2: 18.4194,
    y2: 7.18823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFBD26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1889_14862",
    x1: 10.2666,
    y1: 19.0489,
    x2: 14.0141,
    y2: 19.0489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFBD26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1889_14862",
    x1: 11.09,
    y1: 22.1817,
    x2: 14.46,
    y2: 22.1392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9130"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFBD26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1889_14862",
    x1: 8.33691,
    y1: 11.1445,
    x2: 10.3694,
    y2: 11.1445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1889_14862",
    x1: 14.1328,
    y1: 11.817,
    x2: 17.2278,
    y2: 11.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuara1New);
export default __webpack_public_path__ + "static/media/juara-1-new.cd88a2acdf3b5360e387694df78d2301.svg";
export { ForwardRef as ReactComponent };